import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'ramda-extension';

import { usePlatform } from '../../hooks';

export const PLATFORMS = ['desktop', 'android', 'ios', 'unknown'];

const PlatformCheck = ({ allowed, children }) => {
  const platform = usePlatform();

  if (!platform || allowed.includes(platform))
    return isFunction(children) ? children(platform) : children;

  return <Fragment />;
};

PlatformCheck.propTypes = {
  allowed: PropTypes.arrayOf(PropTypes.oneOf(PLATFORMS)),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.func,
  ]).isRequired,
};

PlatformCheck.defaultProps = {
  allowed: [],
};

export default PlatformCheck;
